import { createReducer, on } from '@ngrx/store';
import { FieldDefValidations } from '@src/suite/common/enums/enums';

import { GlobalTablesActions } from './global-tables.actions';
import { GlobalTablesState } from './global-tables.models';

export const initialGlobalTablesState: GlobalTablesState = {
    Security: [],
    Apps: [],
    Groups: {},
    GroupsArray: [],
    EnterpriseGroup: null,
    PlaybookTeamsArray: [],
    DefaultPlaybookTeam: null,
    EnterprisePlaybookGroup: null,
    FieldMappings: [],
    MOSDevices: [],
    Privileges: [],
    Servers: {},
    Adorners: {},
    WireCategories: [],
    WireProviders: [],
    FieldDefsDict: {},
    StorytellingNavigation: [],
    StorytellingNavigationDict: {},
    CustomFilterDef: [],
    CustomFilterDefsDict: {},
    Languages: [],
    PersonalLanguage: null,
    CommonTimeZones: [],
    IanaTimeZones: [],
    PersonalTimeZone: null,
    PersonalTimeZoneDisplay: null,
    ClientTimeZone: null,
    DefaultTimeZone: null,
    FilterDefs: {},
    GroupSort: null,
    securityPrivileges: {},
    PSTGroupId: null,
    DateTimeFields: {},
};

export const globalTablesReducer = createReducer(
    initialGlobalTablesState,
    on(GlobalTablesActions.setGlobalFields, (state, { fields, groupSortDefs }): GlobalTablesState => {
        const dateTimeFields: { [id: string]: boolean } = {};
        for (const id in fields) {
            if ([FieldDefValidations.TIME, FieldDefValidations.DATE, FieldDefValidations.MOSDATETIME].indexOf(fields[id].Validation.toUpperCase() as FieldDefValidations) > -1) {
                dateTimeFields[id] = true;
            }
        }
        return {
            ...state,
            FieldDefsDict: fields,
            GroupSort: groupSortDefs,
            DateTimeFields: dateTimeFields,
        };
    }),
    on(GlobalTablesActions.setCustomFilterDefs, (state, { customFilterDefs, customFilterDefsDict }): GlobalTablesState => {
        return {
            ...state,
            CustomFilterDef: customFilterDefs,
            CustomFilterDefsDict: customFilterDefsDict,
        };
    }),
    on(GlobalTablesActions.setTimeZoneSettings, (state, { personalTimeZone, personalTimeZoneDisplay, clientTimeZone, defaultTimeZone }): GlobalTablesState => {
        return {
            ...state,
            PersonalTimeZone: personalTimeZone,
            PersonalTimeZoneDisplay: personalTimeZoneDisplay,
            DefaultTimeZone: defaultTimeZone,
            ClientTimeZone: clientTimeZone,
        };
    }),
    on(GlobalTablesActions.updateTimeZoneSettings, (state, { personalTimeZone, personalTimeZoneDisplay }): GlobalTablesState => {
        return {
            ...state,
            PersonalTimeZone: personalTimeZone,
            PersonalTimeZoneDisplay: personalTimeZoneDisplay,
        };
    }),

    on(GlobalTablesActions.setUserLocationPrivileges, (state, { securityPrivileges }): GlobalTablesState => {
        return {
            ...state,
            securityPrivileges: securityPrivileges,
        };
    }),
    on(GlobalTablesActions.setPstGroupId, (state, { PSTGroupId }): GlobalTablesState => {
        return {
            ...state,
            PSTGroupId: PSTGroupId,
        };
    }),
    on(GlobalTablesActions.setGlobalTables, (state, globalTables): GlobalTablesState => {
        return {
            ...state,
            ...globalTables,
        };
    })
);
